import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	padding: 60px 0 60px 60px;
`;

const StyledMenuTabsContainer = styled.div`
	width: 400px;
	margin-top: 40px;
`;

const StyledControlsContainer = styled.div`
	position: absolute;
	bottom: -20px;
	width: max-content;
`;

export { StyledContainer, StyledMenuTabsContainer, StyledControlsContainer };
